// / <reference path="../../../../combination-chart/combination-chart.module.ts" />
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import * as Highcharts from 'highcharts';
import { HttpClient } from '@angular/common/http';
import { BarserviceService } from '../../barservice.service'
// import { url } from 'inspector';

import Stock from 'highcharts/modules/stock';
import { Observable, Subscription } from 'rxjs';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
Stock(Highcharts);
@Component({
  selector: 'app-barchart14',
  templateUrl: './barchart14.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Barchart14Component implements OnInit {
  chart: any;
  event: any;
  datalabel: any = false;
  barChartData: any;
  Highcharts: typeof Highcharts = Highcharts;
  seriesData: any = [];
  changeValue: any;
  properties: any;
  changeValueSeries: any;
  significance: any;
  sampleSize: any;
  @Input() data: any;
  @Input() WidgetDetails: any;
  defaultCategories1: any;
  max: any;
  min: any;
  public seriesData1: any[] = [];
  jsonData: any;
  categories: any;

  labels: any;
  significance2: any;
  categoryImages: any;
  maxDataPoints: any = 6;
  @Input() id: any;
  @Input() height: any;
  @Input() popUp: any;
  @Input() sort: any;

  layoutNumber: any;
  pageNumber: any;
  significanceValue: any = "None";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  DefaultConfidenceLevel: any = "";
  private subscriptions: Subscription = new Subscription();

  constructor(private http: HttpClient, private barService: BarserviceService, private _configService: SnapshotService) { }


  ngOnInit(): void {

    if (this.sort == 0) {
      this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
    }
    this.subscriptions.add(
      this._configService.confedenceValue.subscribe(value => {
        this.DefaultConfidenceLevel = value;
        this.updateSig();
      }));
    this.subscriptions.add(
      this._configService.page2ToggleSubject.subscribe((page: any) => {
        this.layoutNumber = page;
        Barchart14Component.y = page;
      }));


    this.maxDataPoints = this.layoutNumber == 2 ? 12 : this.popUp ? 10 : this.maxDataPoints;
    this.subscriptions.add(
      this._configService.significanceValue.subscribe(value => {
        this.significanceValue = value;
        this.updateSig();
      }));
  }

  chartMainData: any = [];
  updateSig() {
    this.subscriptions.add(
      this.http.get<any>('assets/Data/barData.json').subscribe((data: any) => {
        this.jsonData = data;
        //this.data = data[0];
        this.barChartData = data[0]["data"];
        this.properties = data[0]["properties"][0];
        // ;
        this.properties.datalabelStyle = this.significanceValue == "None" ? "default" : "sigChange";
        this.properties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.properties.datalabelStyle;
        this.Sig_LowerLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigLowerLimit_95;
        this.Sig_UpperLimt =
          this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_95
            ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95
            : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_90
              ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_90
              : this.DefaultConfidenceLevel == COMMON_CONSTANTS_Percentage.ConfidencePercent_98
                ? COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_98
                : COMMON_CONSTANTS_SNAPSHOT.SigUpperLimit_95;
        this.preparemainChartData(this.data);//extra added(req)
        this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
        this.getBarChart('chart-container' + this.id, this.seriesData1, this.properties);
      }));

  }

  ngOnChanges(changes: SimpleChanges) {
    this.updateSig();
    if (this.sort == 0) {
      this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
    }
  }

  preparemainChartData(data: any) {
    let i = 0;

    this.chartMainData = [];
    data.forEach((lev1: any) => {
      lev1.metricSelected.metrics.forEach((lev2: any) => {
        lev2.data.forEach((dataArr: any) => {
          let d1 = {
            "Series Name": lev1.submetricName,
            "Category Name": lev2.metricName,
            "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            //"Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : dataArr.data,
            "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
            "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
            "Change value vs PY": dataArr.changeVsPY,
            "Significance": "-1",
            "Sample size": dataArr.baseValueforLSorIs,
            "Significance2": "1",
            "XValue": ++i,
            "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
            "Sig_LowerLimt": this.Sig_LowerLimt,
            "Sig_UpperLimt": this.Sig_UpperLimt,
            "Significance_Value": dataArr.Significance_Value
          }
          this.chartMainData.push(d1);
        });
      });
    })
  }


  getData(chartData: any, lowSample1: any) {
    let value = 0;
    let i = 0;
    let maxValue = 0;
    let minValue = 0;
    let j = 0;

    chartData[0].data = this.chartMainData; //extra added(req)

    const firstItem = chartData[0].data[0]['Series Name'];//extra added (req)

    const indiaData = chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === firstItem);
    this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
    this.categoryImages = [''].concat(this.categoryImages);
    maxValue = Math.max(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Rounded Value']) || 0));
    minValue = Math.min(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Rounded Value']) || 0));

    this.max = maxValue + Math.ceil(maxValue * 0.20);
    this.min = minValue - Math.floor(minValue * 0.20);
    // ;
    this.seriesData1 = indiaData.map((item: { [x: string]: string }) => ({

      value: (item['Value'] == null || item['Value'] == "NA") ? 0 : this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : parseFloat(item['Value']),
      numericValue: !lowSample1 ? value : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? value : 0),
      name: item['Category Name'],
      color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[j++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
      visible: true,
      zIndex: 2,
      type: 'bar',
      dataLabels: {
        borderWidth: 0,
      },
      data: [{
        name: item['Category Name'],
        ispercent: item["isPercentage"],
        y: this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : (!lowSample1 ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : 0)),
        x: parseInt(item['XValue']),
        seriesName: item['Series Name'],
        indexValue: this._configService.userRole != "superadmin" && Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : (!lowSample1 ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : 0)),
        actualIndexValue: item['ActualIndexValue']
      }],
      changeValueSeries: indiaData.map((item: { [x: string]: string }) => (item["Change value vs PY"])),
      significance: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance"])),
      significance2: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance2"])),
      sampleSize: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Sample size"])),
      roundedValue: indiaData.map((item: { [x: string]: string }) => item["Rounded Value"]),

      //calculationTypes: indiaData.map((item: { [x: string]: string }) => item["CalculationType"]),

      tooltip: [],
      isPercentage: item["isPercentage"],
      Sig_LowerLimt: this.Sig_LowerLimt,
      Sig_UpperLimt: this.Sig_UpperLimt,
      Significance_Value: item["Significance_Value"],

    }));

    if (this.seriesData1.filter((x: any) => x.value == 0).length > 0)
      this.min = 0

    this.labels = indiaData.map((item: { [x: string]: string }) => parseFloat(item["Label"]));

    // this.categories = Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name'])));
    // this.categories = [''].concat(Array.from(new Set(indiaData.map((item: { [x: string]: string }) => item['Category Name']))));

    this.categories = Array.from(indiaData.map((item: { [x: string]: string }) => item['Category Name']));
    this.categories = [''].concat(Array.from(indiaData.map((item: { [x: string]: string }) => item['Category Name'])));



    indiaData.forEach((item: { [x: string]: string }, index: number) => {
      let markerStyle = this.properties.markerStyle;

      // Change marker style to triangle if 'Rounded Value' is negative and marker style is 'triangle'
      if (parseFloat(item['Rounded Value']) < 0 && markerStyle === 'triangle') {
        markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
      }
      this.seriesData1.push({
        name: item['Category Name'],
        type: 'scatter',
        zIndex: 1,
        marker: {
          symbol: markerStyle,
          fillColor: 'red',
          lineColor: 'red',
          lineWidth: 2,
        },
        enableMouseTracking: false,
        showInLegend: false,
        visible: this.properties.marker == 'enable' ? true : false,
        data: [{
          name: item['Category Name'],
          y: !lowSample1 ? item['Rounded Value'] == null ? null : parseFloat(item['Rounded Value']) == 0 ? null : parseFloat(item['Rounded Value']) + (0.02 * parseFloat(item['Rounded Value'])) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['Rounded Value'] == null ? null : parseFloat(item['Rounded Value']) == 0 ? null : parseFloat(item['Rounded Value']) + (0.02 * parseFloat(item['Rounded Value'])) : null),

          x: index + 1,
          z: parseFloat(item['Sample Size']) > this.barService.sampleSizeConstant ? 0 : item['Rounded Value'] == null ? 0 : parseFloat(item['Rounded Value']),
          Sig_LowerLimt: this.Sig_LowerLimt,
          Sig_UpperLimt: this.Sig_UpperLimt,
          Significance_Value: item['Significance_Value']
        }],
      });
    });



  }

  patternselect(ispattern: boolean) {
    this.properties.showPattern = ispattern
    this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
    this.getBarChart('chart-container', this.seriesData1, this.properties);
    ;
  }
  getColor(): string {
    const color = this.barService.colors[this.barService.colorIndex];
    this.barService.colorIndex = (this.barService.colorIndex + 1) % this.barService.colors.length; // Cycle through colors
    return color;
  }
  getDataLabelY(numericValue: number): number {
    // Set the y value based on the sign of numericValue

    return numericValue > 0 ? (numericValue - 50) : -20;
  }

  customization(): Observable<any[]> {
    return this.barService.HorizontalBarcustomizationList();
  }

  applycustomization(event: any, item: string) {
    this.event = event;
    //choose the appropriate customization
    this.barService.applycustomization(event, item, this.properties)
    this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
    this.getBarChart('chart-container', this.seriesData1, this.properties);
  }
  static y = 0;


  getBarChart(containerId: string, seriesData: any[], properties: any) {
    localStorage.setItem("properties", JSON.stringify(this.properties));
    let labels = this.labels;
    let serviceBar = this.barService;
    const updatedCategories = this.categoryImages;


    const maxLabelCharacters = this.popUp ? 30 : 20; // Adjust the maximum number of characters as needed

    const defaultCategories = this.categories;



    const screenHeight = window.innerHeight; // Get the screen width

    let height = '48%';
    if (screenHeight <= 610) { // for 150% -> 593
      height = this.layoutNumber == 2 ? '55%' : '50%';
    } else if (screenHeight <= 800) { // for 125% -> 738
      height = this.layoutNumber == 2 ? (this.popUp ? '50%' : '70%') : '50%';
    } else if (screenHeight <= 1200) { //for 100% -> 953
      height = this.layoutNumber == 2 ? (this.popUp ? '50%' : '100%') : '50%';
    }


    const configService = this._configService;

    const options: Highcharts.Options = {
      chart: {
        type: 'bar',
        height:
          this.layoutNumber == 2 ? (this.popUp ? height : this.height) : height,
        backgroundColor: this.properties.darkTheme
          ? this.barService.darkThemeBackgroundColor
          : this.barService.defaultThemeBackgroundColor,
        style: {
          fontFamily: this.barService.textfont,
          color: this.properties.darkTheme
            ? this.barService.darkThemeTextColor
            : this.barService.defaultThemeTextColor,
          // height:150,
          fontSize: '0.7rem',
        },
        events: {
          //to hide the marker along with the bar,when legend is click for each bar
          redraw: function (this: any) {
            // Adjust scatter series position after redrawing the chart
            var chart = this,
              series = chart.series;

            series.forEach(function (ser: any) {
              if (ser.type === 'column' && ser.type == 'scatter') {
                ser[1].forEach(function (scatter: any) {
                  scatter.setVisible(ser.visible, false);
                });
              }
            });
          },
          load: function () {
            const chart = this;
            // window.addEventListener('resize', function () {
            //   chart.reflow();
            // });
            //#region wheel scroll
            const container = chart.container;
            const xAxis = chart.xAxis[0];

            function onWheel(e: any) {
              e = e || window.event;
              e.preventDefault();

              // Normalize wheel delta
              let delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
              delta = delta > 0 ? -1 : 1; // reverse for natural scrolling

              const extremes = xAxis.getExtremes();
              const step = 1; // how many categories to scroll at a time

              let newMin = extremes.min + delta * step;
              let newMax = extremes.max + delta * step;

              // Bound checks
              if (newMin < extremes.dataMin) {
                newMin = extremes.dataMin;
                newMax = newMin + (extremes.max - extremes.min);
              }
              if (newMax > extremes.dataMax) {
                newMax = extremes.dataMax;
                newMin = newMax - (extremes.max - extremes.min);
              }

              xAxis.setExtremes(newMin, newMax, true, false);
            }

            container.addEventListener('wheel', onWheel, {
              passive: false,
            });
            //#endregion
          },
        },
      },

      title: {
        text: '',
        align: this.properties.chartTitlePosition,
        style: {
          color: this.properties.darkTheme
            ? this.barService.darkThemeTextColor
            : this.barService.defaultThemeTextColor,
          marginleft: '4%',
          fontSize: '2em',
          fontFamily: this.barService.textfont,
        },
      },
      subtitle: {},
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },

      legend: this.barService.customizeLegend(
        this.chart,
        this.properties.showLegend,
        this.properties.legendPosition,
        this.properties
      ),
      xAxis: {
        categories: defaultCategories,
        lineColor: '#A2A2A2', // Change to desired axis line color
        lineWidth: 1,
        min: 1,
        max:
          this.layoutNumber == 2
            ? this.seriesData1.length / 2 <= 12
              ? this.seriesData1.length / 2
              : 12
            : this.seriesData1.length / 2 <= 6
            ? this.seriesData1.length / 2
            : 6,
        scrollbar: {
          enabled:
            defaultCategories.length > this.maxDataPoints + 1 ? true : false,
          height: 6, // Adjust the height of the scrollbar as needed
          barBackgroundColor: '#7f7f7f',//#802AB7,
          barBorderRadius: 5,
          barBorderWidth: 0,
          barBorderColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          buttonBackgroundColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          buttonBorderWidth: 0,
          buttonArrowColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          buttonBorderRadius: 5,
          rifleColor: 'none',
          trackBackgroundColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          trackBorderWidth: 0,
          trackBorderColor: 'black',
          trackBorderRadius: 5,
        },
        showEmpty: false,
        //labels: {
        //  useHTML: true,
        //  formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
        //    let labelContent = String(this.value);

        //    return '<span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; c + '">' + labelContent + '</span>';
        //  },
        //  rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by desired angle
        //}

        labels: {
          useHTML: true,
          style: {
            fontFamily: this.barService.textfont,
            // Add CSS styles for text overflow
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
            color: this.properties.darkTheme
              ? this.barService.darkThemeTextColor
              : this.barService.defaultThemeTextColor,
          },
          formatter: function (
            this: Highcharts.AxisLabelsFormatterContextObject
          ) {
            if (properties.axisImage) {
              let index = defaultCategories.indexOf(String(this.value));
              let i = 0;

              const category1 =
                serviceBar.baseImgPath + updatedCategories[index] + '.png';
              if (category1) {
                return (
                  '<span style="display: inline-block; width: 2em; height: 2em; background: url(' +
                  category1 +
                  ') no-repeat center center; background-size: cover;"></span>'
                );
              } else {
                return '<span>No Image</span>';
              }
            } else {
              let labelContent = String(this.value);

              //// Limit the number of characters only if axis label orientation is vertical
              //if (properties.axisLabelOrientation === "vertical") {
              if (labelContent.length > maxLabelCharacters) {
                labelContent =
                  labelContent.substring(0, maxLabelCharacters) + '...';
              }
              //}

              return `<div title="${String(this.value)}">${labelContent}</div>`;
            }
          },

          overflow: 'justify', // Handle overflow with justification
          rotation: this.barService.axisLabelOrientation(
            this.properties.axisLabelOrientation
          ), // Rotate labels by -90 degrees (or any other desired angle)
        },
      },

      yAxis: {
        max: this.max,
        min: this.min,
        plotLines: [
          {
            value: 0,
            width: 1,
          },
        ],

        gridLineWidth: this.properties.gridlines ? 1 : 0,

        labels: {
          enabled: false,
          format:
            this.properties.datalabelFormat == 'percentage'
              ? '{value}%'
              : '{value}',
          style: {
            fontFamily: this.barService.textfont,
            color: this.properties.darkTheme
              ? this.barService.darkThemeTextColor
              : this.barService.defaultThemeTextColor,
          },
        },
        title: {
          text: '', // Set an empty string to hide the yAxis title
        },
      },
      tooltip: {
        enabled: true,
        borderWidth: 0,
        useHTML: true,
        // shape: properties.toolTipStyle == "style1" ? 'square' : 'callout',
        shadow: false,
        backgroundColor: 'rgba(0,0,0,0)',
        formatter: function (this: any) {
          let x = Barchart14Component.y; //x represent the value for page2toggle subject

          if (this.series.name === 'Marker1') return false;
          let isDefaultTooltip = properties.toolTipStyle;
          // const dotColor = x == 2 ? serviceBar.color1[0] : serviceBar.color1[this.point.x - 1]; // Get the series color
          const dotColor = serviceBar.color1[this.point.x - 1];
          const backgroundcolor = properties.darkTheme ? '#b3b3b3' : '#f5f5f5';
          const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';

          const text = properties.showDataLabel
            ? this.series.userOptions.tooltip[this.point.x - 1]
            : this.y;
          if (isDefaultTooltip == 'style1') {
            const commonContent =
              `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor};  width: fit-content;z-index: 100; padding: 2%; border-radius: 5px; margin: 0; background-color: ${backgroundcolor2};">` +
              //`<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
              // `<span><strong>Series Name:</strong></span> ${this.point.seriesName}<br>` +
              `${this.point.name}: ` +
              ` ${text}`;

            return commonContent + '</div>';
          } else {
            const content =
              `<div style="background-color: ${backgroundcolor}; padding: 10%; align-items: center; border: 1px solid ${dotColor}; width:120%">` +
              `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5%;"> </div>` +
              ` ${this.series.name}` +
              `<div style="display: block; margin-top: 1%;"><strong>Value:</strong> ${text}</div>`;

            return content + '</div>';
          }
        },
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          animation: false,
          allowPointSelect: false,
          states: {
            hover: {
              enabled: false,
            },
            inactive: {
              enabled: false,
            },
            select: {
              enabled: false,
            },
          },
          // animation: this.properties.dataLabelPositionPPT == 'Inside Base' || this.properties.dataLabelPositionPPT == 'Center' || this.properties.dataLabelPositionPPT == 'Inside End' || this.properties.dataLabelPositionPPT == 'Outside End' ? false : true,
          events: {
            //when a legend is clicked fro the bar,bar must disappear
            legendItemClick: function (this: any) {
              var series = this.chart.series,
                selectedSeriesName = this.name;

              // Loop through all series
              for (var i = 0; i < series.length; i++) {
                // Check if the series name matches the clicked legend's series name
                if (series[i].name === selectedSeriesName) {
                  // Toggle visibility of both bar and scatter series
                  series[i].setVisible(!series[i].visible, false);
                  if (series[i].type == 'scatter') {
                    series[i].scatterSeries.setVisible(
                      !series[i].visible,
                      false
                    );
                  }
                }
              }

              // Redraw the chart
              this.chart.redraw();

              // Prevent default legend item click action
              return false;
            },
          },
        },
        bar: {
          pointPadding: 2,
          groupPadding: 3,
          grouping: false,
          stacking: undefined,

          shadow: this.properties.shadow
            ? {
                color: this.barService.shadowColor,
                offsetX: 1,
                offsetY: 1,
                opacity: 0.5,
                width: 6,
              }
            : false,
          pointWidth: 20,

          dataLabels: {
            style: {
              backgroundColor: this.barService.transparentBackground,

              textOutline: 'none',

              color: this.properties.darkTheme
                ? this.properties.dataLabelColor === 'default'
                  ? 'white'
                  : this.properties.dataLabelColor ||
                    this.barService.darkThemeTextColor
                : this.properties.dataLabelColor === 'default'
                ? 'black'
                : this.properties.dataLabelColor ||
                  this.barService.defaultThemeTextColor,
              fontSize: this.properties.dataLabelSize,
              fontWeight: 'normal',
              fontFamily: this.barService.textfont,
            },
            useHTML: true,

            overflow: 'allow',
            crop: false,
            enabled: this.properties.showDataLabel,

            inside: false,
            //  x: this.properties.dataLabel_y_positionHorizontal,
            //  y: this.properties.dataLabel_x_position,
            // x:  this.properties.datalabelStyle == 'default' || this._configService.isIndexSelected?  this.properties.dataLabel_y_positionHorizontal : this.properties.dataLabel_y_positionHorizontal_sig,
            x:
              this.properties.datalabelStyle == 'default'
                ? this.properties.dataLabel_y_positionHorizontal
                : this.properties.dataLabel_y_positionHorizontal_sig,
            y: this.properties.dataLabel_x_position,

            rotation: this.properties.datalabelOrientation,

            align:
              this.properties.dataLabelPosition == 'middle'
                ? 'center'
                : this.properties.dataLabelPosition == 'top'
                ? 'right'
                : 'left',
            allowOverlap: true,

            formatter: function (this: any) {
              if (properties.datalabelStyle == 'index') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y + (this.series.data[0].ispercent ? '%' : '')
                    : serviceBar.nullValueText;
                // ;
                text = configService.CheckLSorIScondition(
                  configService.userRole,
                  text,
                  this.series.userOptions.sampleSize[this.point.x - 1]
                );
                // this.series.userOptions.tooltip[this.point.x - 1] = text;
                // return (
                //   '<span >' + text + '</span>'
                // );

                // let text2 =
                //   this.series.userOptions.roundedValue[this.point.x - 1] === 0
                //     ? serviceBar.nullValueText
                //     : (this.series.userOptions.roundedValue[this.point.x - 1] == -1
                //       ? -1
                //       : ((this.series.userOptions.roundedValue[this.point.x - 1] != null)
                //         ? this.point.indexValue
                //         : serviceBar.nullValueText));
                let text2 =
                  this.point.actualIndexValue == null
                    ? serviceBar.nullValueText
                    : this.series.userOptions.roundedValue[this.point.x - 1] ==
                      -1
                    ? -1
                    : this.series.userOptions.roundedValue[this.point.x - 1] !=
                      null
                    ? this.point.indexValue
                    : serviceBar.nullValueText;
                if (text2 == '-1' || text2 == -1) {
                  text2 = 'NA';
                }
                text2 = configService.CheckLSorIScondition(
                  configService.userRole,
                  text2,
                  this.series.userOptions.sampleSize[this.point.x - 1]
                );

                let color = configService.CheckIndexColoring(text2);
                //// ;
                this.series.userOptions.tooltip[this.point.x - 1] =
                  text + '(' + text2 + ')';
                return (
                  '<span style="font-size:0.5rem;">' +
                  text +
                  '</span>' +
                  '<span style="color:' +
                  color +
                  ';font-size:0.45rem;">' +
                  ' ' +
                  '(' +
                  text2 +
                  ')</span>'
                );
              }

              if (properties.datalabelStyle == 'significance + changeVs') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                let changeText =
                  this.series.userOptions.changeValueSeries[this.point.x - 1];
                let sig =
                  this.series.userOptions.significance[this.point.x - 1];
                let s =
                  sig > 0
                    ? serviceBar.upwardTriangle
                    : sig < 0
                    ? serviceBar.downwardTriangle
                    : '';
                let sigcolor =
                  sig > 0
                    ? serviceBar.highSignificance
                    : sig < 0
                    ? serviceBar.lowSignificance
                    : '';
                if (parseFloat(changeText) > 0) {
                  changeText = '+' + changeText;
                }
                let finalText =
                  '<span>' +
                  '<span>' +
                  text +
                  //+
                  '</span>' +
                  (this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null && changeText
                    ? '<span>&nbsp' +
                      '<span style="font-size: ' +
                      serviceBar.changeValueFontSize +
                      ';color:' +
                      (properties.darkTheme
                        ? serviceBar.darkThemeTextColor
                        : serviceBar.defaultThemeTextColor) +
                      '; ">(' +
                      changeText +
                      ')</span>&nbsp;' +
                      '<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                    : '') +
                  '</span>';

                this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                return finalText;
              }
              if (properties.datalabelStyle == 'sigChange') {
                let changeText = this.series.userOptions.isPercentage
                  ? this.series.userOptions.changeValueSeries[
                      this.point.x - 1
                    ] * 100
                  : this.series.userOptions.changeValueSeries[this.point.x - 1];
                let textCheck = configService.CheckLSorIScondition(
                  configService.userRole,
                  this.y,
                  this.series.userOptions.sampleSize[this.point.x - 1]
                );
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? textCheck +
                      (this.series.userOptions.isPercentage &&
                      textCheck != 'I/S'
                        ? '%'
                        : '')
                    : serviceBar.nullValueText;

                let sig =
                  this.series.userOptions.significance[this.point.x - 1];
                let s =
                  sig > 0
                    ? serviceBar.upwardTriangle
                    : sig < 0
                    ? serviceBar.downwardTriangle
                    : '';
                let sigcolor =
                  sig > 0
                    ? serviceBar.highSignificance
                    : sig < 0
                    ? serviceBar.lowSignificance
                    : '';
                let sigClass =
                  this.series.userOptions.Significance_Value <
                  this.series.userOptions.Sig_LowerLimt
                    ? 'red'
                    : this.series.userOptions.Significance_Value >
                      this.series.userOptions.Sig_UpperLimt
                    ? 'green'
                    : 'black';

                // if (parseFloat(changeText) > 0) {
                //   changeText = "+" + changeText;
                // }
                if (
                  this.series.userOptions.changeValueSeries[this.point.x - 1] ==
                    null ||
                  this.series.userOptions.changeValueSeries[this.point.x - 1] ==
                    'NA'
                ) {
                  let finalText =
                    '<span>' +
                    '<span>' +
                    text +
                    //+
                    '</span>' +
                    (this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? '<span>&nbsp' +
                        '<span style="color:' +
                        sigClass +
                        ';font-size: ' +
                        serviceBar.changeValueFontSize +
                        '; "> (NA)</span>'
                      : '') +
                    '</span>';

                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                  return finalText;
                } else {
                  let finalText =
                    '<span>' +
                    '<span>' +
                    text +
                    //+
                    '</span>' +
                    (this.series.userOptions.Significance_Value == 0
                      ? '<span style="color:' +
                        sigClass +
                        '; font-size: ' +
                        serviceBar.changeValueFontSize +
                        ';">(' +
                        (this.series.userOptions.Significance_Value +
                          (this.series.userOptions.isPercentage ? '%' : '')) +
                        ')' +
                        '</span>'
                      : this.series.userOptions.roundedValue[
                          this.point.x - 1
                        ] != null &&
                        changeText &&
                        textCheck != 'I/S'
                      ? '<span>&nbsp' +
                        '<span style="color:' +
                        sigClass +
                        '; font-size: ' +
                        serviceBar.changeValueFontSize +
                        ';">(' +
                        (parseFloat(Number(changeText).toFixed(1)) +
                          (this.series.userOptions.isPercentage ? '%' : '')) +
                        ')' +
                        '</span>'
                      : '') +
                    '</span>';

                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                  return finalText;
                }
              }
              if (properties.datalabelStyle == 'change') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                let changeText =
                  this.series.userOptions.changeValueSeries[this.point.x - 1];
                if (parseFloat(changeText) > 0) {
                  changeText = '+' + changeText;
                }
                let finalText =
                  '<span>' +
                  text +
                  '  ' +
                  (this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null && changeText
                    ? '<span>&nbsp' +
                      '<span style="font-size: ' +
                      serviceBar.changeValueFontSize +
                      ';color:' +
                      (properties.darkTheme
                        ? serviceBar.darkThemeTextColor
                        : serviceBar.defaultThemeTextColor) +
                      '; ">(' +
                      changeText +
                      ')</span>&nbsp;' +
                      '</span>'
                    : '');
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                return finalText;
              }

              if (properties.datalabelStyle == 'ls') {
                let text =
                  parseFloat(
                    this.series.userOptions.sampleSize[this.point.x - 1]
                  ) > serviceBar.sampleSizeConstant
                    ? this.series.userOptions.roundedValue[this.point.x - 1] !=
                      null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText
                    : serviceBar.lowSampleText;
                let finalText =
                  '<b>' + text + '</b> ' + '<span style="opacity: 0.5"></span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                return finalText;
              }
              if (properties.datalabelStyle == 'significance') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                let sig =
                  this.series.userOptions.significance[this.point.x - 1];
                let s =
                  sig > 0
                    ? serviceBar.upwardTriangle
                    : sig < 0
                    ? serviceBar.downwardTriangle
                    : '';
                let sigcolor =
                  sig > 0
                    ? serviceBar.highSignificance
                    : sig < 0
                    ? serviceBar.lowSignificance
                    : '';
                let finalText =
                  '<span >' +
                  text +
                  (this.series.userOptions.roundedValue[this.point.x - 1] !=
                  null
                    ? '&nbsp<span style="color:' +
                      sigcolor +
                      ';">' +
                      s +
                      '</span>'
                    : '') +
                  '</span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                return finalText;
              }
              if (properties.datalabelStyle == 'default') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y + (this.series.data[0].ispercent ? '%' : '')
                    : serviceBar.nullValueText;
                // ;
                text = configService.CheckLSorIScondition(
                  configService.userRole,
                  text,
                  this.series.userOptions.sampleSize[this.point.x - 1]
                );
                this.series.userOptions.tooltip[this.point.x - 1] = text;
                return '<span >' + text + '</span>';
              }
              if (properties.datalabelStyle == 'datalabel') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                this.series.userOptions.tooltip[this.point.x - 1] = text;
                return '<span >' + text + '</span>';
              }

              if (properties.datalabelStyle == 'significance2') {
                let text =
                  this.series.userOptions.roundedValue[this.point.x - 1] != null
                    ? this.y +
                      (properties.datalabelFormat == 'percentage' ? '%' : '')
                    : serviceBar.nullValueText;
                let changeText =
                  this.series.userOptions.changeValueSeries[this.point.x - 1];
                let sig =
                  this.series.userOptions.significance[this.point.x - 1];
                let sig1 =
                  this.series.userOptions.significance2[this.point.x - 1];
                let sColor =
                  sig > 0
                    ? serviceBar.highSignificance
                    : sig < 0
                    ? serviceBar.lowSignificance
                    : '';
                let s =
                  sig > 0
                    ? serviceBar.upwardTriangle
                    : sig < 0
                    ? serviceBar.downwardTriangle
                    : '';
                let changeColor =
                  sig1 < 0
                    ? serviceBar.lowSignificance
                    : sig1 > 0
                    ? serviceBar.highSignificance
                    : properties.darkTheme
                    ? serviceBar.darkThemeTextColor
                    : serviceBar.defaultThemeTextColor;

                if (parseFloat(changeText) > 0) {
                  changeText = '+' + changeText;
                }
                let finalText =
                  '<span>' +
                  text +
                  (this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null && changeText
                    ? '&nbsp<span style="color:' +
                      (properties.darkTheme
                        ? serviceBar.darkThemeTextColor
                        : serviceBar.defaultThemeTextColor) +
                      ' "> ' +
                      '<span style="font-size:' +
                      serviceBar.changeValueFontSize +
                      '; color:' +
                      changeColor +
                      ';">(' +
                      changeText +
                      ')</span>&nbsp' +
                      '<span style="color:' +
                      sColor +
                      ';">' +
                      s +
                      '</span>'
                    : '') +
                  '</span>';
                this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                return finalText;
              }

              return this.y != 0 ? this.y : serviceBar.nullValueText;
            },
          },
        },
      },
      series: seriesData,
    };
    const containerEl = document.getElementById('chart-container' + this.id);
    if (!containerEl) { return; }
    Highcharts.chart(containerEl, options);

    // let object = {
    //   chartType: "horizontal bar chart",
    //   widgetName: this.WidgetDetails.widgetName,
    //   widgetNumber: this.WidgetDetails.widgetNumber,
    //   pageNumber: this.pageNumber,
    //   data: this.chartMainData,
    //   properties: this.properties,
    //   selectionSummary: this._configService.selectionSummaryTextTitle,
    //   LSthreshold: this._configService.LBthreshold,
    //   ISthreshold: this._configService.ISthreshold,
    //   conversionPercentage: [],
    //   MDSdata: []
    // };

    // this._configService.listOfPptChartObjects.push(object);

  }

  userselectedproperties() {

    this.data["properties"][0] = this.properties;
    return JSON.stringify(this.data).toString();
  }

  index = -1;
  getPatternForImage(imageUrl: any) {
    return {
      pattern: {
        image: imageUrl,
        aspectRatio: 9 / 4
      }
    };
  }


  ngOnDestroy(): void {
    // Unsubscribe to prevent memory leaks and unnecessary reloads
    if (this.chart) { this.chart.destroy(); this.chart = null; }
    this.subscriptions.unsubscribe();
  }
}
